export const CRITERION_VALUE = {
  MET: "MET",
  NOT_MET: "NOT_MET",
  UNKNOWN: "UNKNOWN",
} as const

export type CriterionValue =
  (typeof CRITERION_VALUE)[keyof typeof CRITERION_VALUE]
